export default __webpack_public_path__ + "static/media/IconChooseCustume.fa42ca2d.svg";